import type { Price } from "@stockline/shared/types/pricing/price"
import type { OfflineResourceConfig } from "../../../types"
import { PRICE_TABLE } from "./db"

export const priceConfig: OfflineResourceConfig<Price> = {
  name: "prices",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/prices",
    delta: "/api/v2/prices/changes",
    push: "/api/v2/prices/changes",
  },
  tableName: PRICE_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    productId: "productId",
    clientGroupId: "clientGroupId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
